import Term from "../../term/Term";

export class TermListUploadResult {
  isUploaded: boolean;
  uploadedCount: number;
  duplicatedList: Term[];

  constructor(
    isUploaded: boolean,
    uploadedCount: number,
    duplicatedList: Term[]
  ) {
    this.isUploaded = isUploaded;
    this.uploadedCount = uploadedCount;
    this.duplicatedList = duplicatedList;
  }

  static fromJSON(json: any): TermListUploadResult {
    const isUploaded = json.isUploaded ?? false;
    const uploadedCount = json.uploadedCount ?? 0;
    const duplicatedList: Term[] = (json.duplicatedList ?? []).map(
      (item: any) => Term.fromJson(item)
    );
    return new TermListUploadResult(isUploaded, uploadedCount, duplicatedList);
  }
}
